class JpCartProperty extends HTMLElement {
  #observer = new MutationObserver(() => this.#render());

  connectedCallback() {
    this.#render();
    this.#observer.observe(this, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    this.#observer.disconnect();
  }

  #render() {
    const property = this.closest('[data-jp-property-value]');
    if (!property) return;
    // LPO uses this marker to avoid appending its option price to a property twice.
    const name = (property.dataset.jpPropertyName || '').replace(/^[^a-zA-Z]+|[^\w]+/g, '');
    property.dataset[`p${name.charAt(0).toUpperCase()}${name.slice(1)}`] = '1';
    // Preserve Shopify's saved value even if an app loads after this component.
    const value = property.dataset.jpPropertyValue;
    if (this.textContent !== value) this.textContent = value;
  }
}

if (!customElements.get('jp-cart-property')) {
  customElements.define('jp-cart-property', JpCartProperty);
}
